
import Vue from "vue";
import { AccountantService, IExactSyncRun, IExactSyncRunError } from "@/services/accountant-service";

export default Vue.extend({
	data() {
		return {
			runs: [] as IExactSyncRun[],
			loading: true,
			expanded: null as number | null
		};
	},
	props: {
		dossierId: {
			type: Number,
			required: true
		},
		dossierName: {
			type: String,
			default: ""
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		formatDate(d:string):string {
			if (!d) return "";
			return new Date(d).toLocaleString();
		},
		docLabel(t:string):string {
			if (t == "purchases") return this.$ct("doc.purchases").toString();
			if (t == "dossier") return this.$ct("doc.dossier").toString();
			return this.$ct("doc.sales").toString();
		},
		triggerLabel(t:string):string {
			return this.$ct(t == "manual" ? "trigger.manual" : "trigger.auto").toString();
		},
		toggle(i:number) {
			this.expanded = this.expanded === i ? null : i;
		},
		hasErrors(r:IExactSyncRun):boolean {
			return r.Failed > 0 || this.parseErrors(r.Errors).length > 0;
		},
		parseErrors(raw:string):IExactSyncRunError[] {
			if (!raw) return [];
			try {
				let a = JSON.parse(raw);
				return Array.isArray(a) ? a : [];
			} catch {
				return [];
			}
		},
		async load() {
			this.loading = true;
			try {
				this.runs = await AccountantService.getExactSyncRuns(this.dossierId);
			} catch (err) {
				this.$wf.notify(this.$ct("load-error").toString(), "error", 4000, "exclamation-triangle");
			} finally {
				this.loading = false;
			}
		}
	},
	mounted() {
		this.load();
	},
	i18nEx: {
		componentPrefix: "components.accountant-ExactSyncLogModal"
	}
});
